const getApiUrl = () => {
    if (typeof window === 'undefined') {
      return ''; // Return empty string or handle SSR case if needed
    }
  
    // eslint-disable-next-line prefer-destructuring
    const host = window.location.hostname;

    if (host === 'onboarding.zimtra.ky' || host === 'onboarding.zimtra.com') {
      return 'https://api.zimtra.com'; // Production URL
    }
    // if (host === 'localhost') {
    //   return 'http://localhost:3020';
    // }
    return 'https://dev.api.zimtra.com'; // Default or handle unknown case
  };
  
  export default getApiUrl;
  